import React from "react";
import { useHistory } from "react-router-dom";

import RedesignButton from "~/shared/ui/Fields/RedesignButton";
import { usePermissions } from "~/shared/context/PermissionContext";

interface IQReportControlProps {
  disabledControl?: boolean;
}

export const QReportControl = (props: IQReportControlProps) => {
  const { disabledControl } = props;
  const history = useHistory();
  const goToAppeals = () => history.push(`/staff/appeals`);

  const { hasPermission } = usePermissions();

  if (!hasPermission("employeeAccounting.appeal.getList")) return null;

  return (
    <div>
      <RedesignButton
        theme={"accent"}
        txtBtn={"Подать апелляцию"}
        onClick={goToAppeals}
        disabled={disabledControl}
      />
    </div>
  );
};
